import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';

const builder = new BootstrapBrowserBuilder(
  'satellite-rachel-web',
  Number(process.env.NEXT_PUBLIC_BUILD_NUMBER),
).withHostedAppLoggerOptions('rental-manager-api', process.env.NEXT_PUBLIC_LOG_LEVEL);

if (process.env.NEXT_PUBLIC_DD_APP_ID && process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
  builder.withDatadogPlugin(process.env.NEXT_PUBLIC_DD_APP_ID!, process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!);
}

export const bootstrap = builder.build();
